import { useMutation } from "@apollo/client"
import cn from "classnames"
import React, { useCallback, useEffect, useState } from "react"
import Checkbox from "./checkbox"
import { graphql } from "@/api"

const enableDoc = graphql(`
  mutation EnableAddToCartUpdate($id: Int!) {
    enableAddToCartUpdate(id: $id) {
      enabled
    }
  }
`)

export interface EnableAddToCartProps {
  signId: number
  enabled: boolean
  hangTypeBlank: boolean
}

const EnableAddToCart: React.FC<EnableAddToCartProps> = ({ signId, enabled, hangTypeBlank }) => {
  const [isEnabled, setIsEnabled] = useState(enabled)
  const [enableAddToCartUpdate, enableAddToCartUpdateResult] = useMutation(enableDoc, {
    update: (store, { data }) => {
      if (data?.enableAddToCartUpdate?.enabled === false) {
        setIsEnabled(false)
      } else if (data?.enableAddToCartUpdate?.enabled === true) {
        setIsEnabled(true)
      } else {
        setIsEnabled(enabled)
      }
    },
  })

  const handleClick = useCallback(() => {
    enableAddToCartUpdate({ variables: { id: signId } })
  }, [signId, enableAddToCartUpdate])

  const loading = enableAddToCartUpdateResult?.loading

  const [hydrated, setHydrated] = useState(false)

  useEffect(() => {
    setHydrated(true)
  }, [])

  return (
    <div
      className={cn("flex items-center", { "disabled cursor-not-allowed [&:hover_.tooltip]:visible": hangTypeBlank })}
    >
      <Checkbox
        id={`enable_add_to_cart_${signId}`}
        name={`enable_add_to_cart_${signId}`}
        disabled={loading || hangTypeBlank || !hydrated}
        checked={isEnabled}
        label="Cart"
        onChange={handleClick}
        labelClassName="mt-1"
        inputClassName="enable-add-to-cart"
      />

      <div className="tooltip invisible absolute -ml-20 mb-20 rounded p-1 text-center font-semibold text-ink-100">
        Sign needs fixing method before cart can be enabled
      </div>
    </div>
  )
}

export default EnableAddToCart
